/**
 * Flickity slider module
 *
 * @module Slider
 * @author EN GARDE (Reinhold Seiss)
 * @version 1.0
 */

var EN = EN || {};

EN.Slider = (function ($) {
	'use strict';

	var options = {
		selectors: {
			prdDatesTiles: '.en-mdl-prd-dates__slider',
			prdRecBoxes: '.en-mdl-prd-recommendations__boxes',
			prdAboBoxes: '.en-mdl-prd-abos__boxes',
			prdQuotes: '.en-mdl-prd-quotes__items',
			prdArtists: '.en-mdl-prd-artists__items',
			prdPosts: '.en-mdl-prd-posts__slider',
			videos: {
				module: '.en-mdl-prd-video',
				main: '.en-mdl-prd-video__slider-main',
				nav: '.en-mdl-prd-video__slider-nav',
			},
			teasers: '.en-mdl-teasers__slider',
		}
	};

	/**
	 * Initializes Slider module.
	 * @memberof module:Slider
	 */
	var init = function () {

		$(options.selectors.prdDatesTiles).flickity({
			pageDots: false,
			resize: true,
			contain: true,
			prevNextButtons: true
		});

		$(options.selectors.prdRecBoxes).flickity({
			pageDots: false,
			resize: true,
			contain: true,
			prevNextButtons: true
		});

		// $(options.selectors.prdAboBoxes).flickity({
		// 	pageDots: false,
		// 	resize: true,
		// 	contain: true,
		// 	prevNextButtons: false
		// });

		$(options.selectors.prdQuotes).flickity({
			draggable: false,
			resize: true,
			contain: false,
			freeScroll: false,
			wrapAround: true,
			autoPlay: 5000,
			pageDots: false,
			friction: 0.3,
			selectedAttraction: 0.01,
			prevNextButtons: true,
		});

		$(options.selectors.prdArtists).flickity({
			resize: true,
			contain: true,
			pageDots: false,
			selectedAttraction: 0.01,
			prevNextButtons: true,
			watchCSS: true,
		});


		// VideoContentModule
		$( options.selectors.videos.module ).each(function(){
			var $main = $( options.selectors.videos.main, this );
			var $nav = $( options.selectors.videos.nav, this );
			
			$main.flickity({
				resize: true,
				draggable: true,
				imagesLoaded: true,
				prevNextButtons: false,
				pageDots: true,
				selectedAttraction: 1.0,
				friction: 1.0
			});
			$nav.flickity({
				asNavFor: $main[0],
				contain: true,
				pageDots: false,
				groupCells: true,
				resize: true,
				draggable: true,
			});
		});

		// TeasersContentModule
		$(options.selectors.teasers).flickity({
			contain: true,
			watchCSS: true,
			pageDots: false,
			resize: true,
			prevNextButtons: true,
			groupCells: true,
			friction: 0.4,
		});


		// ProductionPostsContentModule (Blog & News)
		$(options.selectors.prdPosts).flickity({
			resize: true,
			draggable: true,
			groupCells: true,
    		prevNextButtons: true,
    		pageDots: true,
    		watchCSS: true,
			friction: 0.4
		});


	};

	// exports
	return {
		init: init
	};
}(jQuery));
